module.exports = __webpack_public_path__ + "static/media/header.094d9227.png";